import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Container, Rail, Sticky, Grid, Card, Image, Ref, Icon, Divider } from "semantic-ui-react";
import Section1 from "../../containers/RealstatePage/Section1/Section1"
import Section2 from "../../containers/RealstatePage/Section2/Section2"
import "./RealstatePage.css"

const RealstatePage = () => {
    const [fixed, setFixed] = useState(false)
    const isRtl = useSelector((state) => state.main.isRtl)
    const contextRef = useRef(null)
    const onChange = (isVisible) => {
        isVisible ? setFixed(false) : setFixed(true)
        console.log('Element is now %s', isVisible ? 'visible' : 'hidden');
    }

    return (
        <div className="main-cls">
            <Container fluid className="p-1 m-1-t m-5-b">

                <Section1 visibilyChange={onChange} />

                <Container className="m-5-b">
                    {/* <div className="desktop-view">
                        <Grid  columns={2}>
                            <Grid.Column  width={10}>
                                <Ref innerRef={contextRef}>
                                    <Container>
                                        <Rail position={isRtl ? 'right' : 'left'} className="w-60 p-0 m-3-t m-3-b">
                                            <Sticky context={contextRef} offset={100}>
                                                <ReservationCard />
                                            </Sticky>
                                        </Rail>
                                        <Section2 fixed={fixed} />
                                    </Container>
                                </Ref>
                            </Grid.Column>
                        </Grid>
                    </div> 
                    <div className="tablet-view">
                        <Section2 fixed={fixed} />
                    </div>*/}
                        <Section2 fixed={fixed} />

                </Container>
            </Container>
        </div>
    )
}
export default RealstatePage